import { render, staticRenderFns } from "./AddNewCar.vue?vue&type=template&id=4905a0ee&"
import script from "./AddNewCar.vue?vue&type=script&lang=js&"
export * from "./AddNewCar.vue?vue&type=script&lang=js&"
import style0 from "./AddNewCar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports